import fetch from "../utils/fetch";
import {setAllowRedirect, showLoader} from "./appActions";
import { redirectTo, alertBackendError } from "../utils";
import { REQUESTS } from "../actions/constants";
import {getApiPrefix_lagoon, getApiPrefix_touch} from "../constants";

export const sampleRequests = () => async (dispatch, getState) => {
  try {
    const response = await fetch(`${getApiPrefix_touch()}/host/`);

    if (
      (response.status === 401 || response.status === 403) &&
      getState().app.allowRedirect
    ) {
      dispatch(setAllowRedirect(false));
      const url = await response.text();
      redirectTo(url);
    } else if (response.status === 500 || response.status === 503) {
      alertBackendError({response});
    }

    return response.status === 200;
  } catch (exception) {
    console.log(exception);
    alertBackendError({exception});
    return false;
  }
};

export const getRequest = ({
  includeCount,
  limit,
  side,
  status,
  project,
  recipient,
  sender
}) => async (dispatch, getState) => {
  let query = "";

  query += `${includeCount
    ? query === ""
      ? `includeCount=${includeCount}`
      : `&includeCount=${includeCount}`
    : ""}`;
  query += `${limit
    ? query === "" ? `limit=${limit}` : `&limit=${limit}`
    : ""}`;
  query += `${side ? (query === "" ? `side=${side}` : `&side=${side}`) : ""}`;
  query += `${status
    ? query === "" ? `status=${status}` : `&status=${status}`
    : ""}`;
  query += `${project
    ? query === "" ? `project=${project}` : `&project=${project}`
    : ""}`;
  query += `${recipient
    ? query === "" ? `recipient=${recipient}` : `&recipient=${recipient}`
    : ""}`;
  query += `${sender
    ? query === "" ? `sender=${sender}` : `&sender=${sender}`
    : ""}`;

  try {
    const response = await fetch(`${getApiPrefix_lagoon()}/auth/request?${query}`);

    if (
      (response.status === 401 || response.status === 403) &&
      getState().app.allowRedirect
    ) {
      dispatch(setAllowRedirect(false));
      const url = await response.text();
      redirectTo(url);
    } else if (response.status === 200) {
      const content = await response.json();

      if (side === "NOT_PENDING") {
        dispatch({
          type: REQUESTS,
          payload: { requestsOther: { ...content, limit } }
        });
      } else if (side === "PENDING") {
        dispatch({
          type: REQUESTS,
          payload: { requestsMe: { ...content, limit } }
        });
      } else {
        dispatch({
          type: REQUESTS,
          payload: { requests: { ...content, limit } }
        });
      }

      return true;
    } else if (response.status === 500 || response.status === 503) {
      alertBackendError({response});
    }

    if (side === "NOT_PENDING") {
      dispatch({ type: REQUESTS, payload: { requestsOther: null } });
    } else if (side === "PENDING") {
      dispatch({
        type: REQUESTS,
        payload: { requestsMe: null }
      });
    } else {
      dispatch({
        type: REQUESTS,
        payload: { requests: null }
      });
    }

    return false;
  } catch (exception) {
    console.log(exception);
    alertBackendError({exception});
    return false;
  }
};

export const setFilter = (
  initial,
  accepted,
  resolving,
  resolved,
  closed,
  dismissed,
  textQuery,
  limit,
  dateType,
  date
) => {
  var ret = {
      type: REQUESTS,
      payload: {
          filter: {
              initial,
              accepted,
              resolving,
              resolved,
              closed,
              dismissed,
              textQuery,
              limit,
              dateType,
              date
          }
      }
  };
  return ret;
};

export const getRequestWithFilter = (side, recipient, sender, filter) => async (
  dispatch,
  getState
) => {

  filter = filter || getState().request.filter;

  const extra = {side, filter};

  let status = "";

  status += `${filter.initial ? (status === "" ? "INITIAL" : ",INITIAL") : ""}`;
  status += `${filter.accepted
    ? status === "" ? "ACCEPTED" : ",ACCEPTED"
    : ""}`;
  status += `${filter.resolving
    ? status === "" ? "RESOLVING" : ",RESOLVING"
    : ""}`;
  status += `${filter.resolved
    ? status === "" ? "RESOLVED" : ",RESOLVED"
    : ""}`;
  status += `${filter.closed ? (status === "" ? "CLOSED" : ",CLOSED") : ""}`;
  status += `${filter.dismissed
    ? status === "" ? "DISMISSED" : ",DISMISSED"
    : ""}`;

  const date = new Date();
  const year = date.getFullYear();
  const month = date.getMonth();

  const since = filter.date
    ? filter.date === "THIS_MONTH"
      ? new Date(year, month, 1, 0, 0, 0, 0)
      : filter.date === "PREVIOUS_MONTH"
        ? new Date(year, month - 1, 1, 0, 0, 0, 0)
        : new Date()
    : null;
  const before = filter.date
    ? filter.date === "THIS_MONTH" || filter.date === "PREVIOUS_MONTH"
      ? new Date(year, month + 1, 0, 0, 0, 0, 0)
      : new Date()
    : null;

  if (
    since &&
    before &&
    filter.date !== "THIS_MONTH" &&
    filter.date !== "PREVIOUS_MONTH"
  ) {
    if (filter.date === "TODAY") {
      before.setDate(before.getDate() + 1);
    } else if (filter.date === "YESTERDAY") {
      since.setDate(since.getDate() - 1);
    } else if (filter.date === "THIS_WEEK") {
      since.setDate(since.getDate() - since.getDay() + 1);
      before.setDate(since.getDate() + 7);
    } else if (filter.date === "PREVIOUS_WEEK") {
      since.setDate(since.getDate() - since.getDay() - 6);
      before.setDate(since.getDate() + 7);
    } else if (filter.date === "LAST_7_DAYS") {
      since.setDate(since.getDate() - 6);
      before.setDate(before.getDate() + 1);
    } else if (filter.date === "LAST_14_DAYS") {
      since.setDate(since.getDate() - 13);
      before.setDate(before.getDate() + 1);
    } else if (filter.date === "LAST_30_DAYS") {
      since.setDate(since.getDate() - 29);
      before.setDate(before.getDate() + 1);
    }

    since.setHours(0, 0, 0, 0);
    before.setHours(0, 0, 0, 0);
  }

  try {
    const response = await fetch(
      `${getApiPrefix_lagoon()}/auth/request?includeCount=true${side
        ? `&side=${side}`
        : ""}&limit=${filter.limit}${status === ""
        ? ""
        : `&status=${status}`}${filter.textQuery === ""
        ? ""
        : `&textQuery=${filter.textQuery}&lang=cs`}${filter.date &&
      filter.date !== "ANY"
        ? `&${filter.dateType === "CREATED"
            ? "createdSince"
            : "modifiedSince"}=${since.getTime()}&${filter.dateType ===
          "CREATED"
            ? "createdBefore"
            : "modifiedBefore"}=${before.getTime()}`
        : ""}${recipient ? `&recipient=${recipient}` : ""}${sender
        ? `&sender=${sender}`
        : ""}`
    );

    if (
      (response.status === 401 || response.status === 403) &&
      getState().app.allowRedirect
    ) {
      dispatch(setAllowRedirect(false));
      const url = await response.text();
      redirectTo(url);
    } else if (response.status === 200) {
      const content = await response.json();

      if (side === "NOT_PENDING") {
        dispatch({
          type: REQUESTS,
          extra,
          payload: { requestsOther: { ...content } }
        });
      } else if (side === "PENDING") {
        dispatch({
          type: REQUESTS,
          extra,
          payload: { requestsMe: { ...content } }
        });
      } else {
        dispatch({
          type: REQUESTS,
          extra,
          payload: { requests: { ...content } }
        });
      }

      return true;
    } else if (response.status === 500 || response.status === 503) {
      alertBackendError({response});
    }

    if (side === "NOT_PENDING") {
      dispatch({ type: REQUESTS, payload: { requestsOther: null }, extra });
    } else if (side === "PENDING") {
      dispatch({ type: REQUESTS, payload: { requestsMe: null }, extra });
    } else {
      dispatch({ type: REQUESTS, payload: { requests: null }, extra });
    }

    return false;
  } catch (exception) {
    console.log(exception);
    alertBackendError({exception});
    return false;
  }
};

export const inviteProvider = (sender, to, subject, messageBody) => async (
  dispatch,
  getState
) => {
  try {
    const response = await fetch(`${getApiPrefix_lagoon()}/auth/request`, {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json"
      }),
      body: JSON.stringify({
        language: "cs",
        messageBody,
        pendingSide: "RECIPIENT",
        recipients: [{ identifier: to }],
        sender,
        severity: 5,
        status: "INITIAL",
        subject,
        type: "INVITE_PROVIDER"
      })
    });

    if (
      (response.status === 401 || response.status === 403) &&
      getState().app.allowRedirect
    ) {
      dispatch(setAllowRedirect(false));
      const url = await response.text();
      redirectTo(url);
    } else if (response.status === 200 || response.status === 201) {
      const content = await response.json();
      return content;
    } else if (response.status === 500 || response.status === 503) {
      alertBackendError({response});
    }

    return false;
  } catch (exception) {
    console.log(exception);
    alertBackendError({exception});
    return false;
  }
};

export const newProject = (sender, sponsor, name, text) => async (
  dispatch,
  getState
) => {
  try {
    const response = await fetch(`${getApiPrefix_lagoon()}/auth/request`, {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json"
      }),
      body: JSON.stringify({
        customFields: [
          { name: "projectName", value: name },
          { name: "projectDescription", value: text }
        ],
        language: "cs",
        messageBody: "Přijetím této žádosti vytvoříte nový projekt.",
        pendingSide: "RECIPIENT",
        recipients: [{ identifier: sponsor }],
        sender,
        severity: 0,
        status: "INITIAL",
        subject: `Vytvořit nový projekt: ${name}`,
        type: "CREATE_PROJECT"
      })
    });

    if (
      (response.status === 401 || response.status === 403) &&
      getState().app.allowRedirect
    ) {
      dispatch(setAllowRedirect(false));
      const url = await response.text();
      redirectTo(url);
    } else if (response.status === 200 || response.status === 201) {
      const content = await response.json();
      return content;
    } else if (response.status === 500 || response.status === 503) {
      alertBackendError({response});
    }

    return false;
  } catch (exception) {
    console.log(exception);
    alertBackendError({exception});
    return false;
  }
};

export const newRequest = (
  sender,
  to,
  customType,
  severity,
  subject,
  messageBody,
  project,
  estimatedDuration,
  priceCurrency,
  priceAmount,
  priceTaxAmount
) => async (dispatch, getState) => {
  try {
    const response = await fetch(`${getApiPrefix_lagoon()}/auth/request`, {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json"
      }),
      body: JSON.stringify({
        customType,
        estimatedDuration,
        formIdentifier: "com.atollon.form.request",
        language: "cs",
        messageBody,
        pendingSide: "RECIPIENT",
        priceAmount,
        priceCurrency,
        priceTaxAmount,
        project: project ? { identifier: project } : undefined,
        recipients: [{ identifier: to }],
        sender,
        severity,
        status: "INITIAL",
        subject,
        type: "GENERIC"
      })
    });

    if (
      (response.status === 401 || response.status === 403) &&
      getState().app.allowRedirect
    ) {
      dispatch(setAllowRedirect(false));
      const url = await response.text();
      redirectTo(url);
    } else if (response.status === 200 || response.status === 201) {
      const content = await response.json();
      return content;
    } else if (response.status === 500 || response.status === 503) {
      alertBackendError({response});
    }

    return false;
  } catch (exception) {
    console.log(exception);
    alertBackendError({exception});
    return false;
  }
};

export const newRequestWithInputAsStruct = (bodyAsStruct) => async (dispatch, getState) => {

  // TODO: finish sending this request
  //console.log(`/api/jersey/auth/request`, bodyAsStruct);
  //return;

    try {
        const response = await fetch(`${getApiPrefix_lagoon()}/auth/request`, {
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json"
            }),
            body: JSON.stringify( bodyAsStruct )
        });

        if (
            (response.status === 401 || response.status === 403) &&
            getState().app.allowRedirect
        ) {
            dispatch(setAllowRedirect(false));
            const url = await response.text();
            redirectTo(url);
        } else if (response.status === 200 || response.status === 201) {
            const content = await response.json();
            return content;
        } else if (response.status === 500 || response.status === 503) {
            alertBackendError({response});
        }
        else
        {
            const text = await response.text();

            let json;
            try
            {
                json = JSON.parse( text );
            }
            catch( _ )
            {
                json = null;
            }

            if (response.status === 200 || response.status === 201)
            {
                return { response: json, text, json };
            }
            else
            {
                alertBackendError({response, parsedResponse: { text, json }});
                return false;
            }
        }

        return false;
    } catch (exception) {
        console.log(exception);
        alertBackendError({exception});
        return false;
    }
};

export const updateRequest = request => async (dispatch, getState) =>
{
  const response = await putJSONGetResponse({url: `${getApiPrefix_lagoon()}/auth/request/${request.hash}`, data: request, dispatch, getState });

  console.log( "updateRequest", {response} );

  if( response.response !== null )
  {
    return true;
  }
  else
  {
    return false;
  }
};

export const getRequestById = id => async (dispatch, getState) => {
  try {
    const response = await fetch(`${getApiPrefix_lagoon()}/auth/request/${id}`);

    if (
      (response.status === 401 || response.status === 403) &&
      getState().app.allowRedirect
    ) {
      dispatch(setAllowRedirect(false));
      const url = await response.text();
      redirectTo(url);
    } else if (response.status === 200) {
      const content = await response.json();
      dispatch({
        type: REQUESTS,
        payload: { request: content }
      });
    } else if (response.status === 500 || response.status === 503) {
      alertBackendError({response});
    }

    return response.status === 200;
  } catch (exception) {
    console.log(exception);
    alertBackendError({exception});
    return false;
  }
};

export const postNewRequest = ( parameters ) => async (dispatch, getState) =>
{
    let { url, data } = parameters;
    let result = false;

    if( parameters.alertBefore )
    {
        alert( parameters.alertBefore );
    }
    if( parameters.showLoader )
    {
        dispatch(showLoader(true));
    }

    try {
        const response = await fetch( url, {
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json"
            }),
            body: JSON.stringify( data )
        });

        if (
            (response.status === 401 || response.status === 403) &&
            getState().app.allowRedirect
        ) {
            dispatch(setAllowRedirect(false));
            const url = await response.text();
            redirectTo(url);
        } else if (response.status === 200 || response.status === 201) {
            const content = await response.json();

            result = content;

        } else if (response.status === 500 || response.status === 503) {
            alertBackendError({response});
        }

    } catch (exception) {
        console.log(exception);
        alertBackendError({exception});
    }

    if( parameters.showLoader )
    {
        dispatch(showLoader(false));
    }

    return result;
};

export const putJSONOrNull_result_JSON = 0;
export const putJSONOrNull_result_TEXT = 1;
export const putJSONOrNull_result_IGNORE = 2;

export const putJSONOrNull = ({ url, data, result }) => async (dispatch, getState) => {

    result = result || putJSONOrNull_result_JSON;

    try {
        const response = await fetch(
            url,
            {
                method: "PUT",
                headers: new Headers({
                    "Content-Type": "application/json"
                }),
                body: JSON.stringify( data )
            }
        );

        if (
            (response.status === 401 || response.status === 403) &&
            getState().app.allowRedirect
        ) {
            alertBackendError({ response, parsedResponse: {}});
            dispatch(setAllowRedirect(false));
        } else if (response.status === 200 || response.status === 201) {
            if( result === putJSONOrNull_result_TEXT )
            {
                const content = await response.text();
                return content || true;
            }
            else if( result === putJSONOrNull_result_JSON )
            {
                const content = await response.json();
                return content || true;
            }
            else
            {
                return true;
            }
        } else if (response.status === 500 || response.status === 503) {
            alertBackendError({response});
        }

        return null;
    } catch (exception) {
        console.log(exception);
        alertBackendError({exception});
        return null;
    }
};

const putJSONGetResponse = async ({ url, data, dispatch, getState }) =>
{
    try
    {
        const response = await fetch(
            url,
            {
                method: "PUT",
                headers: new Headers({
                    "Content-Type": "application/json"
                }),
                body: JSON.stringify( data )
            }
        );

        const text = await response.text();

        let json;
        try
        {
          json = JSON.parse( text );
        }
        catch( _ )
        {
          json = null;
        }

        if (response.status === 200 || response.status === 201)
        {
          return { response: json, text, json };
        }
        else
        {
          alertBackendError({response, parsedResponse: { text, json }});
          return { response: null, text, json };
        }
    }
    catch (exception)
    {
        console.log(exception);
        alertBackendError({exception});
        return { response: null, text: null, json: exception };
    }
};


// WEBPACK FOOTER //
// ./src/actions/requestActions.js